import { SitesService } from './sites/sites.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { destroyGrooveHQWidget } from 'app/groovehq';
import { DASHBOARD_ROUTE } from 'app/app-routing.constants';
import User from '@shared/models/user';
import { LoginSuccess } from '@shared/services/auth-api.service';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  constructor(
    private readonly http: HttpClient,
    private readonly auth: AuthService,
    private readonly sites: SitesService,
  ) {}

  // Auth

  async connectAsUser(user: ImpersonateRequest, organizationCode: string) {
    this.http
      .post<LoginSuccess>('v2/auth/connectAs', {email: user.email})
      .subscribe((res) => {
        this.auth.purgeContext();
        this.auth.purgeSessionStorage();
        this.sites.purgeContext();
        this.auth.setCacheOrganizationCode(res, organizationCode);
        this.auth.user = new User(res);
        destroyGrooveHQWidget();
        window.location.href = `/#/${DASHBOARD_ROUTE}`;
        window.location.reload();
      });
  }
}

export type ImpersonateRequest = { email: string };
